import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcNextChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.36321 20.6368C7.01174 20.2853 7.01174 19.7155 7.36321 19.364L14.7268 12.0004L7.36321 4.6368C7.01174 4.28533 7.01174 3.71548 7.36321 3.36401C7.71468 3.01254 8.28453 3.01254 8.636 3.36401L16.636 11.364C16.9875 11.7155 16.9875 12.2853 16.636 12.6368L8.63601 20.6368C8.28453 20.9883 7.71469 20.9883 7.36321 20.6368Z",
		fill: "currentColor"
	})
});
export default SvgIcNextChevron;
